// //import {Route, Routes} from 'react-router-dom'
import { Routes, Route } from 'react-router-dom';
import './App.css';

//import ProtectedRoute from './Components/ProtectedRoute';
import Mobile from './Components/mobile';
import Maintenance from './Components/maintainance';
import NotFound from './Components/NotFound'
import Launch from './Components/Launch';
import Home from './Components/Home';

const App = () => (
  <Routes>
    <Route exact path="/" element={<Home />} />
    <Route path='*' element={<NotFound />} />
  </Routes>
)


// import TestCheck from "./Components/test";
// import { GoogleOAuthProvider } from "@react-oauth/google";

// const App = () => {
//   return (
//     <GoogleOAuthProvider clientId="65624971031-c79iip89339fj189hsosb2ej9atepf83.apps.googleusercontent.com">
//       <TestCheck />
//     </GoogleOAuthProvider>
//   );
// };

export default App;
